// Template301: Bali - Día con caja verde y sección imagen (Page5-style)
// Cabecera, hero, intro, bloques: default | highlightedBox (verde) | imageSection (imagen ancho con SabiasQue/tip/sticker).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template301 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const logoImage = getCanvasImageUrl("logo");
	const blocks = Array.isArray(page?.data?.blocks) ? page.data.blocks : [];
	const footerBox = page?.data?.footerBox;
	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
		marginTop: 1,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};
	const tipBoxStyle = {
		backgroundColor: "#fff8db",
		border: "2px solid #f5c400",
		borderRadius: "12px 12px 0 12px",
		padding: "10px 12px",
		fontSize: 11,
		color: contentColor,
		boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{/* Cabecera */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Hero */}
			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 90, position: "absolute", bottom: 60, left: 20 }}
						/>
					)}
					{heroTitle && (
						<Box
							component="span"
							sx={{
								fontSize: isSmallScreen ? 28 : 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
							dangerouslySetInnerHTML={{ __html: heroTitle }}
						/>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", paddingBottom: "5px" }}>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginTop: "-10px" }}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1,
						marginTop: 1.25,
						marginBottom: isSmallScreen ? 2 : 0,
					}}
				>
					{blocks.map((block, idx) => {
						const blockType = block.type || "default";
						const blockImage = block.imageId
							? getImageSrc(block.imageId)
							: null;
						const sabiasQueList = Array.isArray(block.sabiasQue)
							? block.sabiasQue
							: [];
						const stickerImageId = block.stickerImageId;
						const inlineStickerImageId = block.inlineStickerImageId;
						const tipBox = block.tipBox;
						const stickerImage = stickerImageId
							? getImageSrc(stickerImageId)
							: null;
						const inlineStickerImage = inlineStickerImageId
							? getImageSrc(inlineStickerImageId)
							: null;

						// highlightedBoxWithTipLeft: caja verde con sticker flotante dentro + tip/sticker abajo izquierda (Page9)
						if (blockType === "highlightedBoxWithTipLeft") {
							return (
								<Box key={idx} data-block-id={`text-${idx + 3}`} sx={{ position: "relative" }}>
									<Box
										sx={{
											position: "relative",
											backgroundColor: "#c8e6d4",
											borderRadius: "12px",
											padding: 2.5,
											width: "100%",
										}}
									>
										{inlineStickerImage && (
											<Box
												component="img"
												src={inlineStickerImage}
												alt=""
												sx={{
													width: isSmallScreen ? 105 : 115,
													float: "right",
													marginRight: -3.5,
													marginTop: -2.5,
												}}
											/>
										)}
										{block.titulo && (
											<Box component="h3" sx={estiloH3}>
												{block.titulo}
											</Box>
										)}
										{block.contenido && (
											<Box
												component="p"
												sx={{ ...estiloP, fontSize: 13 }}
												dangerouslySetInnerHTML={
													typeof block.contenido === "string" &&
													block.contenido.includes("<")
														? { __html: block.contenido }
														: undefined
												}
											>
												{typeof block.contenido === "string" &&
												!block.contenido.includes("<")
													? block.contenido
													: null}
											</Box>
										)}
									</Box>
									{tipBox && (tipBox.titulo || tipBox.texto) && (
										<Box
											sx={{
												position: "absolute",
												bottom: isSmallScreen ? -30 : -40,
												left: isSmallScreen ? 60 : 5,
												maxWidth: isSmallScreen ? 200 : 120,
												zIndex: 6,
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "12px 12px 12px 0px",
												padding: "10px 12px",
												fontSize: 11,
												color: contentColor,
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												fontFamily: `${
													fontFamily || "'Poppins', sans-serif"
												} !important`,
											}}
										>
											{tipBox.titulo && <strong>{tipBox.titulo}</strong>}
											{tipBox.texto &&
												(tipBox.texto.includes("<") ? (
													<span
														dangerouslySetInnerHTML={{ __html: tipBox.texto }}
													/>
												) : (
													tipBox.texto
												))}
										</Box>
									)}
									{stickerImage && (
										<Box
											component="img"
											src={stickerImage}
											alt=""
											sx={{
												width: 100,
												position: "absolute",
												bottom: isSmallScreen ? -90 : -110,
												left: -20,
												zIndex: 5,
											}}
										/>
									)}
								</Box>
							);
						}

						// highlightedBoxWithTipTopLeft: caja verde con tip y sticker arriba a la izquierda (Page15 Atuh)
						if (blockType === "highlightedBoxWithTipTopLeft") {
							return (
								<Box key={idx} data-block-id={`text-${idx + 3}`} sx={{ position: "relative", marginTop: 2 }}>
									{tipBox && (tipBox.titulo || tipBox.texto) && (
										<Box
											sx={{
												position: "absolute",
												top: 70,
												left: 14,
												maxWidth: 120,
												zIndex: 6,
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "12px 12px 0 12px",
												padding: "10px 12px",
												fontSize: 11,
												color: contentColor,
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												fontFamily: `${
													fontFamily || "'Poppins', sans-serif"
												} !important`,
											}}
										>
											{tipBox.titulo && <strong>{tipBox.titulo}</strong>}
											{tipBox.texto &&
												(tipBox.texto.includes("<") ? (
													<span
														dangerouslySetInnerHTML={{ __html: tipBox.texto }}
													/>
												) : (
													tipBox.texto
												))}
										</Box>
									)}
									{stickerImage && (
										<Box
											component="img"
											src={stickerImage}
											alt=""
											sx={{
												width: 120,
												position: "absolute",
												top: 100,
												left: -20,
												zIndex: 5,
											}}
										/>
									)}
									<Box
										sx={{
											backgroundColor: "#c8e6d4",
											borderRadius: "12px",
											padding: 1.5,
											width: "100%",
										}}
									>
										{block.titulo && (
											<Box component="h3" sx={estiloH3}>
												{block.titulo}
											</Box>
										)}
										{block.contenido && (
											<Box component="p" sx={{ ...estiloP, padding: 0 }}>
												{block.contenido}
											</Box>
										)}
									</Box>
								</Box>
							);
						}

						// highlightedBox: caja verde con sticker + tip + titulo/contenido
						if (blockType === "highlightedBox") {
							return (
								<Box
									key={idx}
									data-block-id={`text-${idx + 3}`}
									sx={{
										display: "flex",
										gap: 2,
										position: "relative",
										backgroundColor: "#c8e6d4",
										borderRadius: "12px",
										marginBottom: isSmallScreen ? 2 : 0,
									}}
								>
									<Box sx={{ width: "100%", position: "relative" }}>
										{stickerImage && (
											<Box
												component="img"
												src={stickerImage}
												alt=""
												sx={{
													width: 100,
													position: "absolute",
													bottom: isSmallScreen ? -140 : -30,
													right: 0,
													zIndex: 999,
												}}
											/>
										)}
										{tipBox && (tipBox.titulo || tipBox.texto) && (
											<Box
												sx={{
													position: "absolute",
													bottom: isSmallScreen ? -70 : 40,
													right: 2,
													maxWidth: 180,
													zIndex: 999,
													backgroundColor: "#fff8db",
													border: "2px solid #f5c400",
													borderRadius: "12px 12px 0 12px",
													padding: "10px 12px",
													fontSize: 11,
													color: contentColor,
													boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
													fontFamily: `${
														fontFamily || "'Poppins', sans-serif"
													} !important`,
												}}
											>
												{tipBox.titulo && <strong>{tipBox.titulo}</strong>}
												{tipBox.texto &&
													(tipBox.texto.includes("<") ? (
														<span
															style={{ marginTop: 0 }}
															dangerouslySetInnerHTML={{ __html: tipBox.texto }}
														/>
													) : (
														tipBox.texto
													))}
											</Box>
										)}
										<Box
											sx={{
												...estiloP,
												padding: 2,
												marginTop: 0,
												width: isSmallScreen ? "100%" : "70%",
											}}
										>
											{block.titulo && (
												<Box component="h3" sx={{ ...estiloH3, marginTop: 0 }}>
													{block.titulo}
												</Box>
											)}
											{block.contenido}
										</Box>
									</Box>
								</Box>
							);
						}

						// imageSection: imagen ancho con SabiasQue (top), tip y sticker (bottom left)
						if (blockType === "imageSection") {
							const sectionImage = block.imageId
								? getImageSrc(block.imageId)
								: null;
							if (!sectionImage) return null;
							return (
								<Box key={idx} data-block-id={`text-${idx + 3}`} sx={{ position: "relative" }}>
									<Box
										component="img"
										src={sectionImage}
										alt=""
										sx={{
											width: "100%",
											height: isSmallScreen ? 200 : 100,
											objectFit: "cover",
										}}
									/>
									{sabiasQueList.map((sq, i) => (
										<Box
											key={i}
											sx={{
												position: "absolute",
												top: isSmallScreen ? 60 : -10,
												left:
													(sq.leftPercent != null
														? sq.leftPercent
														: i === 0
														? 52
														: 40) + "%",
												zIndex: 2,
											}}
										>
											<SabiasQue
												icono={sq.icono || "💬"}
												texto={sq.texto || ""}
											/>
										</Box>
									))}
									{tipBox && (tipBox.titulo || tipBox.texto) && (
										<Box
											sx={{
												position: "absolute",
												bottom: isSmallScreen ? 30 : 50,
												left: 40,
												maxWidth: 160,
												zIndex: 6,
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "12px 12px 12px 0px",
												padding: "10px 12px",
												fontSize: 11,
												color: contentColor,
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												fontFamily: `${
													fontFamily || "'Poppins', sans-serif"
												} !important`,
											}}
										>
											{tipBox.titulo && <strong>{tipBox.titulo}</strong>}{" "}
											{tipBox.texto}
										</Box>
									)}
									{stickerImage && (
										<Box
											component="img"
											src={stickerImage}
											alt=""
											sx={{
												width: 100,
												position: "absolute",
												bottom: -20,
												left: -20,
												zIndex: 5,
											}}
										/>
									)}
								</Box>
							);
						}

						// default: bloque con imagen + sabiasQue o solo sticker+tip (sin imagen)
						const isStickerTipOnly =
							!blockImage &&
							(stickerImage || (tipBox && (tipBox.titulo || tipBox.texto)));
						if (isStickerTipOnly) {
							return (
								<Box key={idx} data-block-id={`text-${idx + 3}`} sx={{ position: "relative" }}>
									<Box sx={{ width: "80%" }}>
										{block.titulo && (
											<Box
												component="h3"
												sx={{ ...estiloH3, marginTop: isSmallScreen ? 0 : 1 }}
											>
												{block.titulo}
											</Box>
										)}
										{block.contenido && (
											<Box component="p" sx={estiloP}>
												{block.contenido}
											</Box>
										)}
									</Box>
									{stickerImage && (
										<Box
											component="img"
											src={stickerImage}
											alt=""
											sx={{
												width: 100,
												position: "absolute",
												bottom: 0,
												right: -10,
											}}
										/>
									)}
									{tipBox && (tipBox.titulo || tipBox.texto) && (
										<Box
											sx={{
												position: "absolute",
												bottom: 50,
												right: 60,
												maxWidth: 200,
												zIndex: 6,
												...tipBoxStyle,
											}}
										>
											{tipBox.titulo && <strong>{tipBox.titulo}</strong>}{" "}
											{tipBox.texto}
										</Box>
									)}
								</Box>
							);
						}

						return (
							<Box
								key={idx}
								data-block-id={`text-${idx + 3}`}
								sx={{
									display: "flex",
									gap: 2.5,
									alignItems: "flex-start",
									position: "relative",
									marginTop: idx === 0 ? 0 : isSmallScreen ? 10 : 1,
								}}
							>
								{blockImage && (
									<Box
										component="img"
										src={blockImage}
										alt=""
										sx={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
											flexShrink: 0,
										}}
									/>
								)}
								{sabiasQueList.length > 0 &&
									sabiasQueList.map((sq, i) => (
										<Box
											key={`sq-${idx}-${i}`}
											sx={{
												position: "absolute",
												top:
													sq.topOffset != null
														? `${sq.topOffset}px`
														: `${i * 40 - 10}px`,
												left:
													sq.leftPercent != null ? `${sq.leftPercent}%` : "32%",
												zIndex: 2,
											}}
										>
											<SabiasQue
												icono={sq.icono || "💬"}
												texto={sq.texto || ""}
											/>
										</Box>
									))}
								<Box
									sx={{
										width: blockImage ? "60%" : "100%",
										position: "relative",
									}}
								>
									{block.titulo && (
										<Box component="h3" sx={estiloH3}>
											{block.titulo}
										</Box>
									)}
									{block.contenido && (
										<Box component="p" sx={estiloP}>
											{block.contenido}
										</Box>
									)}
								</Box>
							</Box>
						);
					})}
				</Box>
				{footerBox?.content && (
					<Box
						data-block-id="text-footer"
						sx={{
							backgroundColor: "#c8e6d4",
							border: "2px solid #2F6B4F",
							borderRadius: "12px",
							padding: "8px 16px",
							fontSize: 13,
							color: contentColor,
							marginTop: 1.5,
							...(footerBox.center && { textAlign: "center" }),
						}}
					>
						<Box
							component="p"
							sx={{ ...estiloP, margin: 0 }}
							dangerouslySetInnerHTML={{ __html: footerBox.content }}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template301.thumbnail = "/images/template-1.png";
export default Template301;
